import axios from 'axios';

import { reportAxiosError } from '~/Utils';
import { getLobFromPolicy } from '~/Utils/lobUtils';

// The policy types configurable FNOL has a form for; the policy search only ever offers these.
export const CONFIGURABLE_FNOL_POLICY_TYPES = ['auto_policy', 'general_policy'];

interface CreateLikePolicy {
  // A manual policy's id is a client-side uuid, not a policy row.
  id?: number | string;
  is_manual?: boolean;
  lob?: string;
  type?: string;
  sub_organization?: { id: number } | null;
}

// Pre-fill is best-effort: a failed draft fetch is reported but never blocks taking the loss.
export const fetchCreateLikeDraft = async (
  sourceClaimId: number,
  policy: CreateLikePolicy
): Promise<Record<string, unknown> | null> => {
  try {
    const response = await axios.get(`/api/v1/claims/${sourceClaimId}/create_like_draft`, {
      params: {
        target_lob: getLobFromPolicy(policy),
        target_sub_organization_id: policy.sub_organization?.id ?? undefined,
        // A policy entered manually has no row for the backend to look up; without one it carries
        // everything but the insured vehicle.
        ...(policy.is_manual ? {} : { target_policy_id: policy.id }),
      },
    });
    const draft = response.data?.draft;
    return draft && Object.keys(draft).length > 0 ? draft : null;
  } catch (error) {
    // `openDialogError = false`: reportAxiosError defaults it to true, which would pop the
    // top-level error dialog (or the permission-denied dialog on a 403) over the FNOL screen the
    // moment the user picks a policy. Sentry still gets the error; the user gets an empty form.
    await reportAxiosError(error, false);
    return null;
  }
};
